/**
 * Supported unlock targets exposed by the media API.
 *
 * @readonly
 * @enum {string}
 */
export const UnlockTargetEnum = Object.freeze({
    PARK: 'Park',
    PHOTO: 'Photo',
    VIDEO: 'Video',
});

/**
 * Builds the shared request used by park, photo, and video unlock operations.
 */
export default class UnlockMediaRequest {
    constructor({ unlockTarget, albumKey, mediaIds = [] } = {}) {
        if (!Object.values(UnlockTargetEnum).includes(unlockTarget)) {
            throw new TypeError(`Unsupported unlock target: ${unlockTarget}`);
        }
        if (!albumKey?.Id || !albumKey?.Token) {
            throw new TypeError('AlbumKey is required for media unlocking.');
        }

        this.UnlockTarget = unlockTarget;
        this.AlbumKey = albumKey;

        if (unlockTarget === UnlockTargetEnum.PHOTO || unlockTarget === UnlockTargetEnum.VIDEO) {
            if (!Array.isArray(mediaIds) || mediaIds.length === 0) {
                throw new TypeError('MediaIds is required for photo and video unlocking.');
            }
            this.MediaIds = [...new Set(mediaIds.map(Number))];
        }
    }
}

/**
 * Represents the encrypted album context required for unlocking.
 */
export class AlbumKey {
    constructor({ id = '', token = '' } = {}) {
        this.Id = id;
        this.Token = token;
    }
}
